import React, { useState, useEffect } from "react";
import { functions } from "../firebase/firebase"; // Assuming firebase setup is correct
import { httpsCallable } from "firebase/functions";
import { auth } from "../firebase/firebase";
const StockAnalysisTable = ({ stockId }) => {
  
  const [intrinsicValue, setIntrinsicValue] = useState(null);
  const [futShareVal, setFutShareVal] = useState(null);
  const [worthOfCashFlows, setWorthOfCashFlows] = useState(null);
  const [roundedTerminalValue, setRoundedTerminalValue] = useState(null);
  const [roundedTotalValue, setRoundedTotalValue] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [currentPriceDate, setCurrentPriceDate] = useState(null);
  const [discountAvailable, setDiscountAvailable] = useState(null);
  const [error, setError] = useState(null);
  

  useEffect(() => {

    const fetchStockDetails = async () => {
      const updateValueFn = httpsCallable(functions, "updateValue");
      try {
        
        const response = await updateValueFn({ id: stockId });

        setIntrinsicValue(response.data.intrinsicValue);
        setFutShareVal(response.data.futShareVal);
        setWorthOfCashFlows(response.data.worthOfCashFlows);
        setRoundedTerminalValue(response.data.roundedTerminalValue);
        setRoundedTotalValue(response.data.roundedTotalValue);
        setCurrentPrice(response.data.currentPrice);
        setCurrentPriceDate(response.data.formattedCurrentPriceDate);
        setDiscountAvailable(response.data.discountAvailable);
         //  console.log("Response data:", response.data);
        //  console.log("discountAvailable:", response.data.discountAvailable);
        
      } catch (err) {
        setError(err.message);
        console.error("Error occurred:", err);
      }
    };

    fetchStockDetails();
  }, [stockId]);

  return (
    <table className="min-w-full table-auto border-collapse">
      <tbody>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2">
            Worth of Cash Flows (Cr):
          </td>
          <td className="border border-gray-300 px-4 py-2 text-right">
            {worthOfCashFlows !== null ? worthOfCashFlows : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2 bg-gray-100">
            Terminal Value (Cr):
          </td>
          <td className="border-gray-300 px-4 py-2 text-right">
            {roundedTerminalValue !== null ? roundedTerminalValue : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2">
            Total Value of Company (Cr):
          </td>
          <td className="border border-gray-300 px-4 py-2 text-right">
            {roundedTotalValue !== null ? roundedTotalValue : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2">
            Future Value Per Share (INR):
          </td>
          <td className="border px-4 py-2 text-right">
            {futShareVal !== null ? futShareVal : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2 text-xs">
            INTRINSIC VALUE (including Book Value - INR):
          </td>
          <td className="border border-gray-300 px-4 py-2 text-right">
            {intrinsicValue !== null ? intrinsicValue : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2">
            Current Price (INR):
          </td>
          <td className="border px-4 py-2 text-right">
            {currentPrice !== null ? currentPrice : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2">
            Current Price Updated On:
          </td>
          <td className="border border-gray-300 px-4 py-2 text-right">
            {currentPriceDate !== null ? currentPriceDate : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-white even:bg-gray-100 text-black text-xs">
          <td className="border border-gray-300 px-4 py-2">
            DISCOUNT AVAILABLE (%):
          </td>
          <td
            className="border  border-gray-300 px-4 py-2 text-right"
            style={{
              color:
                discountAvailable > 50
                  ? "green"
                  : discountAvailable < 0
                  ? "red"
                  : "black",
            }}
          >
            <strong>
              {discountAvailable !== null ? discountAvailable : "N/A"}
            </strong>
          </td>
        </tr>
        {error && (
          <tr>
            <td
              colSpan="2"
              className="border border-gray-300 px-4 py-2 text-red-500 text-xs"
            >
              Error: {error}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default StockAnalysisTable;
